"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NPC = void 0;
const gotti_1 = require("gotti");
const types_1 = require("../../Shared/types");
const Position_1 = require("../../Shared/Components/Position");
const Component_1 = require("../Systems/NPCMovement/Component");
class NPC extends gotti_1.Entity {
    constructor(type) {
        super(1, types_1.EntityTypes.NPC);
        this.action = 'idle';
        this.npcType = type;
    }
    initialize(data) {
        this.addComponent(new Position_1.Position(data === null || data === void 0 ? void 0 : data.x, data === null || data === void 0 ? void 0 : data.y));
        // this.addComponent(new PathfindingComponent(data.pathfinder))
        this.addComponent(new Component_1.NPCMovementComponent(types_1.GameValues.PlayerSpeed, data.skeleton));
    }
    onNextDialogue(nextDialogue, callback) {
        this.nextDialogue = nextDialogue;
        this.nextDialogueCallback = callback;
    }
    getNextDialogue() {
        if (!this.nextDialogue)
            return null;
        if (typeof this.nextDialogue === 'function') {
            return this.nextDialogue();
        }
        else {
            return this.nextDialogue;
        }
    }
}
exports.NPC = NPC;
//# sourceMappingURL=module.js.map